import { Card, Space, Input, Flex, Button, Upload, notification, message, Row, Col, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { NAV_TO_PROFILE_LIST, RESOURCE_TYPE_PROFILES } from '@/resources-def/profiles-comp';
import { importProfile, exportProfile } from '@/apis/profiles';
import { useOne } from "@/hooks";

const { Text } = Typography;
export const ImportPage = () => {
  const [fileContent, setFileContent] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useResourceNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [name,setName] = useState('');
  const [desc,setDesc] = useState('');
  const { t } = useTranslation();
  const { rootState} = useResourceContext();
  const handleCancel = () => {
    navigate({ resource: NAV_TO_PROFILE_LIST, action: "list" });
  };
  const handleBeforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      let content = e.target.result;    
      let obj = JSON.parse(content);
      setSelectedFile(obj);
      setFileContent(JSON.stringify(obj.profile, null, 2));
      setName(obj.name);
      setDesc(obj.desc);
    };
    reader.readAsText(file);
    return false; 
  };
  const handleImport = async () => {
    if (!selectedFile) {
      return;
    }
    const formData = new FormData();
    if(name){
      selectedFile.name = name;
    }
    if(desc){
      selectedFile.desc = desc;
    }
    const content = JSON.stringify(selectedFile);
    const blob = new Blob([content], { type: 'application/json' })
    formData.append('fileupload', blob, 'upload.json');
    //formData.append('fileupload', selectedFile);

    const response = await importProfile(formData);
    if (response.status === "OK") {
      rootState?.eks?.data["instance-profiles"].push(name);
      navigate({ resource: NAV_TO_PROFILE_LIST, action: "list" });
    } else {
      notification.error({
        description: `Failed to import instance profile.${response.message}`,
      });
    }
  };
  return (
    <Card title="Import Profile" 
    style={{ maxWidth: 900, minHeight: 200, marginTop: 0, width: "100%", height: "100%"}}>
      <Space direction="vertical" size={16} style={{ width: '100%', height: "100%" }}>
      <Flex justify="space-between" align="center"  >
        <span><Text strong>Definition:</Text></span>
        <Upload
        beforeUpload={handleBeforeUpload}
        showUploadList={false}
        accept=".txt, .json"
      >
          <Button type="primary">Browse...</Button>
        </Upload>
      </Flex>
        <Input.TextArea
          value={fileContent}
          readOnly
          rows={17}
          style={{width:"100%", resize:"none" }}
        />

          <Row align="top" style={{ marginBottom: 8 }}>
            <Col span={3} ><Text strong>{t("settings.profiles.fields.name")}</Text></Col>
            <Col span={21}><Input value={name} readOnly={selectedFile == null} onChange={(e) => setName(e.target.value)}/></Col>
          </Row>

          <Row align="top" style={{ marginBottom: 8 }}>
            <Col span={3} ><Text strong>{t("settings.profiles.fields.desc")}</Text></Col>
            <Col span={21}>
              <Input.TextArea
                readOnly={selectedFile == null}
                value={desc}
                rows={2}
                style={{width:"100%", resize:"none" }}
                onChange={(e) => setDesc(e.target.value)}
              />          
            </Col>
          </Row>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleImport} disabled={!selectedFile}>
            Import
          </Button>
        </div>
      </Space>
    </Card>
  );
};
export const ExportPage = () => {
  const { state } = useResourceContext();
  const selected = state.selectedResources[0];
  const [fileContent, setFileContent] = useState('');
  const { t } = useTranslation();
  
  const { data, isLoading } = useOne({
    resource: RESOURCE_TYPE_PROFILES,
    id: selected?.name,
    skip: !selected,
  });
  const instance = data || selected;

  const navigate = useResourceNavigate();
  const handleCancel = () => {
    navigate({ resource: NAV_TO_PROFILE_LIST, action: "list" });
  };
  const handleExport = async () => {

    const response = await exportProfile(selected.name);
    if (response.status === "error") {
      notification.error({
        description: `Failed to export profile ${selected.name}.${response.message||""}`,
      });

    } else {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `profile_${selected.name}.json`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      navigate({ resource: NAV_TO_PROFILE_LIST, action: "list" });
    }
  };
  return (
    <Card title={`Export Profile`} 
    style={{ maxWidth: 900, minHeight: 200, marginTop: 0, width: "100%", height: "100%"}}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Row align="top" style={{ marginBottom: 8 }}>
          <Col span={3} ><Text strong>{t("settings.profiles.fields.name")}</Text></Col>
          <Col span={21}><Input value={instance?.name} disabled={true}/></Col>
        </Row>

        <Row align="top" style={{ marginBottom: 8 }}>
          <Col span={3} ><Text strong>{t("settings.profiles.fields.desc")}</Text></Col>
          <Col span={21}>
            <Input.TextArea
              disabled={true}
              value={instance.desc}
              rows={2}
              style={{width:"100%", resize:"none" }}
            />          
          </Col>
        </Row>
        <div><Text strong>Definition</Text></div>
        <Input.TextArea
          value={JSON.stringify(instance.profile||"{}", null, 2)}
          readOnly
          rows={20}
          style={{width:"100%", resize:"none" }}
        />

        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleExport}>
            Export
          </Button>
        </div>
      </Space>
    </Card>
  );
};
